module.exports = __webpack_public_path__ + "static/img/liuliulife.2980002d.jpg";